import { getPaginationLimit } from 'SharedPartialsLocal/getPaginationLimit';
import IndexTemplate from './ComposedIndexTemplate';
import { IndexPageQuery } from './IndexQuery.graphql';

IndexTemplate.query = IndexPageQuery;
IndexTemplate.queryVars = getPaginationLimit;

export default IndexTemplate;
